import React, { memo, useEffect } from "react";
import { Controller, useFieldArray } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import RequiredTitle from "./RequiredTitle";

const MultiplePhoneInputField = ({ input, control, error, defaultValue }) => {
  const {
    name,
    label,
    validation,
    defaultValues = defaultValue,
    alignment = {},
  } = input;
  const { sm = 12, md = 12, lg = 12 } = alignment;

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name,
  });

  useEffect(() => {
    if (fields?.length === 0 && defaultValues?.length > 0) {
      replace(defaultValues);
    } else if (fields?.length === 0) {
      replace([{ phone: "" }]);
    }
  }, [fields, defaultValues, replace]);


  const addRow = () => {
    append({ phone: "" });
  };

  const removeRow = (index) => {
    if (fields?.length > 1) {
      remove(index)
    }
  };

  return (
    <div className={`form-group mb-3 col-sm-${sm} col-md-${md} col-lg-${lg}`}>
      <RequiredTitle
        label={label}
        validation={validation}
      />
      <div>
        {fields.map((field, index) => {
          return (
            <div key={field.id} className="d-flex align-items-center mb-2">
              <Controller
                name={`${name}[${index}].phone`}
                control={control}
                rules={validation}
                defaultValue={defaultValues?.[index]?.phone || ''}
                render={({ field }) => (
                  <PhoneInput
                    {...field}
                    value={field.value || ""}
                    country="in"
                    inputStyle={{
                      width: "100%",
                      height: "3.5rem",
                    }}
                    onChange={(value) => field.onChange(value || "")} // Update field value
                  />
                )}
              />
              <span className="btn-icon-start-danger ms-2" onClick={() => removeRow(index)}>
                  <i className="fa fa-trash color-info" />
              </span>
            </div>
          )
        })}
        <span className="btn-icon-start-danger ms-1 mt-1" onClick={addRow}>
            <i className="fa fa-plus color-info" />
        </span>
      </div>
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

export default memo(MultiplePhoneInputField);
